export { default } from "./CadastrarLead";
